import URI from "urijs";
import getUrl from "./getUrl";

export default function transformDocUrl(url: string, parentContentID: string) {
  if (!url || url.startsWith("xref:")) {
    return url;
  } else if (url && (url.startsWith("/support") || url.startsWith("/partnership") || url.startsWith("/try-it-out"))) {
    return getUrl(url);
  }

  let newHref = URI(url)
    .absoluteTo(`/${parentContentID}`)
    .toString()
    .substring(1);
  let parts = newHref.split("#");
  newHref = URI("/docs")
    .query({ id: parts[0] })
    .toString();
  if (parts.length > 1) {
    newHref = `${newHref}#${parts[1]}`;
  }
  return newHref;
}
